import Cookies from 'js-cookie'

export const clearStmCookies = (): void => {
  Object.keys(Cookies.get()).forEach((name) => {
    if (name.startsWith('stm_')) Cookies.remove(name)
  })
}
